import { Icon } from "@/react/components/shared/Icon";

interface QuotationMarkProps {
  color: string;
}

export const QuotationMark = ({ color }: QuotationMarkProps) => (
  <Icon
    type="20-open-quote"
    useWithFillCurrentColor
    useWithStrokeCurrentColor
    style={{ color }}
    viewBox="0 0 20 20"
  />
);
